import { Link } from "react-router-dom";
import LoadingComponent from "../../common/LoadingComponent";
import { useChunkCache } from "../cache/useChunkCache";
import "../styles/report-preview.css";
import "../../PreviewPdf/PreviewPDF.css";
import VirtualizedReportList from "./VirtualizedReportList";

const ReportPreviewView = ({
  propertyMasterId,
  inspectionReferenceNumber,
  clientNameParam,
}) => {
  const {
    chunkCache,
    pageModel,
    loading,
    error,
    fetchingMore,
    handleVisibleRange,
    ensureChunkLoaded,
  } = useChunkCache({
    propertyMasterId,
    inspectionReferenceNumber,
    enabled: true,
  });

  const routeParams = {
    clientNameParam,
    propertyMasterId,
    inspectionReferenceNumber,
  };

  const printPath = `/client/${clientNameParam}/report/print/${propertyMasterId}/${inspectionReferenceNumber}`;

  return (
    <div className="report-preview">
      <header className="report-preview__toolbar no-print">
        <Link
          to={`/client/${clientNameParam}/property-view-details/${propertyMasterId}/${inspectionReferenceNumber}`}
          className="report-preview__back"
        >
          Back
        </Link>
        <h1 className="report-preview__title">Report Preview</h1>
        <Link to={printPath} className="report-preview__print-link">
          Print view
        </Link>
      </header>

      {error && (
        <p className="report-preview__error">
          Failed to load report. Please try again.
        </p>
      )}

      <div className="report-preview__viewport preview-pdf-wrapper">
        <div className="report-preview__pages">
          {!loading && pageModel.length > 0 && (
            <VirtualizedReportList
              pageModel={pageModel}
              chunkCache={chunkCache}
              routeParams={routeParams}
              onVisibleRange={handleVisibleRange}
              ensureChunkForPage={ensureChunkLoaded}
            />
          )}
          {fetchingMore && (
            <p className="report-preview__loading-more no-print">
              Loading more…
            </p>
          )}
        </div>
        <LoadingComponent loading={loading} />
      </div>
    </div>
  );
};

export default ReportPreviewView;
